module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"current":"current","team":"About us"},"de":{"current":"aktiv","team":"Über uns"}}')
  delete Component.options._Ctor
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./node_modules/yaml-loader!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=1!./src/components/Navbar.vue
// module id = Wyw0
// module chunks = 0